import './IconButton.scss';

interface Props {
  icon: string;
  onClick: (...args: any) => void;
}

export default function IconButton({
  icon,
  onClick,
}: Props) {
  return (
    <div className='IconButton'>
      <button
        className='Button'
        onClick={onClick}
      >
        <img
          className='Icon'
          alt=''
          src={icon}
        />
      </button>
    </div>
  );
}
